import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Link, useParams } from "react-router-dom"
import { requestParentScrollToTop } from "../../../helper/embedViewport"
import BookingSummary from "../../partials/BookingSummary"

// The confirmation replaces the payment step at the same address, so it
// brings itself into view. Its height follows the content: embedded at full
// height, 100vh would keep the iframe as tall as the form and leave the
// confirmation off screen. The summary shows what was booked and paid.
const SuccessPage = ({ summary = null }) => {
  const { t } = useTranslation()
  const { tenant } = useParams()

  useEffect(() => {
    window.scrollTo(0, 0)
    requestParentScrollToTop()
  }, [])

  return (
    <div className="booking-success">
      <div className="booking-success__card" role="status">
        <svg
          className="booking-success__icon"
          viewBox="0 0 24 24"
          width="64"
          height="64"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="11" fill="currentColor" />
          <path
            d="M7 12.5l3.2 3.2L17 9"
            fill="none"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <h2 className="booking-success__title">{t("book_success")}</h2>
        <p className="booking-success__text">{t("apt_confirm")}</p>
        {summary?.selectedProperty && (
          <div className="booking-success__summary">
            <BookingSummary {...summary} />
          </div>
        )}
        <Link to={`/${tenant}`} className="booking-success__button">
          {t("back_home")}
        </Link>
      </div>
    </div>
  )
}

export default SuccessPage
